import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f987bb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "truncate text-sm" }

import { Ref, ref, watch } from 'vue';
import AppDropdownIcon from '@/components/Base/AppDropdownIcon.vue';
import AppIcon from '@/components/Base/AppIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategorySidemenuItem',
  props: {
  title: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  active: {
    type: Boolean,
    default: false,
  },
},
  emits: {
  effect: null,
},
  setup(__props, { emit }) {

const props = __props;





const isActive: Ref<boolean> = ref(props.active);

const triggerCategorySidemenuItemEffect = (): void => {
  emit('effect');
};

watch(
  (): boolean => {
    return props.active;
  },
  (): void => {
    isActive.value = props.active;
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", null, [
    _renderSlot(_ctx.$slots, "before", { active: isActive.value }),
    _createElementVNode("button", {
      class: _normalizeClass({
        'flex w-full cursor-pointer items-center justify-between gap-x-3 border p-3': true,
        'button-inactive-state': !isActive.value,
        'border-lighten button-active-state': isActive.value,
      }),
      onClick: triggerCategorySidemenuItemEffect
    }, [
      _createVNode(AppIcon, {
        class: "-my-[4px] h-[24px]",
        src: require(`@/assets/images/${props.icon}`)
      }, null, 8, ["src"]),
      _createElementVNode("span", _hoisted_1, _toDisplayString(props.title), 1),
      _createVNode(AppDropdownIcon, {
        class: "-my-[8px] h-[32px] drop-shadow-md",
        active: isActive.value
      }, null, 8, ["active"])
    ], 2),
    _renderSlot(_ctx.$slots, "after", { active: isActive.value })
  ]))
}
}

})